let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lzICY")).then(() => parcelRequire('84yl1'));